import React from "react";

import ObaForm from "./ObaForm";

const ObaSurveyFormComp = (props) => {
  let statusClass = "panel-status";
  if (props.config && props.config.status && props.config.status.state) {
      statusClass = `${statusClass} ${props.config.status.state}`;
  }
  
  return (
    <div className="form">
        <div className="form-header">
            <div className="form-header-label">{props.editorMode === "UPDATE"?"Update":"Create a New"} Outside Business Activities Request</div>
        </div>
        <ObaForm
            editorMode={props.editorMode}
            editorItem = { { id: props.data.id, formData: props.data.formData, template: props.data.template } }
            isReadOnly = { props.config.detailMode === "POSTREVIEW" }
            data = { props.data }
            onUserSelected = {props.onUserSelected}
            onComplete= { props.handleSubmitSurvey }
        />
        <div className="form-footer">
            <div className={statusClass}>{props.config.status.message}</div>
            <div className="btn-group">
            <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={props.handleCancel}>
                {props.config.detailMode === "POSTREVIEW" ? "Close" : "Cancel"}
            </button>
            {(props.config.detailMode === "POSTREVIEW" && props.editorMode === "NEW") && 
                <button type="button" id="btnSave" className="btn btn-primary" onClick={props.config.btnOk.handler}>{props.config.btnOk.label}</button>
            }
            </div>
        </div>
    </div>
    )
}


export default ObaSurveyFormComp;